import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getAddReviewList = createAsyncThunk(
  "addReviewList/getAddReviewList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/review/add_review`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const addReviewSlice = createSlice({
  name: "addReviewList",
  initialState: {
    loading: false,
    addReviewData: null,
    error: null,
  },
  reducers: {
    ResetAddReviewState: (state) => {
      state.loading = false;
      state.addReviewData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddReviewList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAddReviewList.fulfilled, (state, action) => {
        state.loading = false;
        state.addReviewData = action.payload;
      })
      .addCase(getAddReviewList.rejected, (state, action) => {
        state.loading = false;
        state.addReviewData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetAddReviewState } = addReviewSlice.actions;
export default addReviewSlice.reducer;
